import { useCallback } from 'react'
import { Popup } from 'components/Popup'
import { Button, BUTTON_TYPES } from 'components/Button'
import { Typography } from 'components/Typography'
import { BTN_TXT } from 'constants/txt'
import { useFinancialsPopup } from 'features/Financials/Providers/FinancialsPopupProvider'
import { FINANCIAL_TABS } from 'features/Financials/constants'
import useRouter from 'hooks/useRouter'
import { routes } from 'router'
import { formatAmount } from 'helper/common'
import { TUnresolvedRebateQuarter } from './types'
import './styles.scss'

export const UnresolvedRebateQuartersPopup = () => {
  const {
    unresolvedRebateQuarters: { state, actions },
    invoicesDetailsPopup
  } = useFinancialsPopup()
  const { navigate } = useRouter()
  const { unresolvedRebateQuarters } = state.payload

  const onClose = () => actions.close()

  const onOpenRebateInvoices = useCallback(
    (quarter: TUnresolvedRebateQuarter) => {
      actions.close()
      invoicesDetailsPopup.actions.close()
      actions.close()
      navigate(
        `${routes.financials}/${FINANCIAL_TABS[0].key}?invoiceId=${
          quarter.uuid
        }&period_ending=${encodeURIComponent(quarter.period_ending)}`
      )
    },
    [actions, invoicesDetailsPopup.actions, navigate]
  )

  return (
    <Popup
      {...state}
      width={442}
      zIndex={10000}
      className="unresolved-rebate-quarters"
      footer={
        <Button type={BUTTON_TYPES.PRIMARY} onClick={onClose} upperCase>
          {BTN_TXT.GOT_IT}
        </Button>
      }
    >
      <div className="unresolved-rebate-quarters__content column gap-16">
        <Typography.Body1>
          Some AP invoices in this calculation are also part of rebate
          calculations that haven&apos;t been resolved.
        </Typography.Body1>
        <div className="column gap-8">
          <Typography.Body1>
            Resolve the related calculations first:
          </Typography.Body1>
          {!!unresolvedRebateQuarters?.length && (
            <ul className="unresolved-rebate-quarters__calculations">
              {unresolvedRebateQuarters.map((item) => (
                <li key={item.uuid} onClick={() => onOpenRebateInvoices(item)}>
                  <Typography.Body1 className="main-color-text">
                    {item.hospital_name} · {formatAmount(item.total)}
                  </Typography.Body1>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </Popup>
  )
}
